import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="menu.play-my-mood" defaultMessage="Play My Mood" />;
